<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="typeCommentId"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <template #default>

        <t-input v-model="form.typeCommentId" hidden/>

        <b-col cols="12" class="mb-2">

          <b-row>

            <b-col xl="9">

              <b-row>

                <t-input cols="4" v-model="form.name"  :add-error="error.name" label="Tipo de Conteúdo"
                         required/>

                <t-input cols="4" v-model="form.color" color-reduced label="Cor" required/>

                <t-input cols="4" v-model="form.note" label="Observação"/>


              </b-row>

            </b-col>

            <b-col xl="3" class="button-form-inline">

              <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

              <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                {{ t('go-back') }}
              </b-link>

            </b-col>

          </b-row>

        </b-col>

      </template>

      <template #item(color)="{item}">

        <span class="badge badge-dot badge-dot-xl mr-2"
              :style="{'background-color': item.color}"></span> {{ item.color }}

      </template>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'TypeComment',
  data() {
    return {
      path: "general/type-comment", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "pageId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "typeCommentId", keyDelete: "typeCommentId"},
        {key: "name", label: "Tipo de Conteúdo", cols: "4"},
        {key: "color", label: "Cor", cols: "3"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        pageId: this.foreignKey,
        //---------------------------------------------------------------
        //PADRÃO FORMULÁRIO GROUP-PRODUCT
        typeCommentId: 0,
        name: "",
        note: "",
        color: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },

      //FIM FORMULÁRIO PADRÃO GROUP PRODUCT -------------------------------
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
        "codeGeneratorUsing",
        "codeGeneratorQtdNumbers"
      ],
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      if (!this.form.codeGeneratorUsing) {
        this.form.codeGeneratorQtdNumbers = 0
      }

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.typeCommentId)

    },

    mountedList() {
      

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
   
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
